<template>
  <a v-if="link" class="delivery-chips" target="_blank" :href="link">
    <ui-icon icon="local_shipping"></ui-icon>{{$t('order.label.item.tracking.parcel-tracking')}}
  </a>
  <span v-else>{{$t('order.label.item.tracking.parcel-tracking-nolink')}}</span>
</template>

<script>
  export default {
    name: 'status-chips',
    props: ['link']
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  a.delivery-chips {
    display: inline-block;
    font-size: 12px;
    color: $body-light;
    padding: 3px 8px;
    border-radius: 5px;
    background-color: $somfy;
    text-decoration: none;

    &:link, &:visited, &:hover, &:active, &:focus {
      color: $body-light;
    }

    &:hover {
      background-color: lighten($somfy, 8%);
    }

    i {
      margin-right: 10px;

      /* flip horizontaly the icon */
      -moz-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      transform: scaleX(-1);
      -ms-filter: fliph; /*IE*/
      filter: fliph; /*IE*/
    }
  }
</style>



// WEBPACK FOOTER //
// DeliveryChips.vue?37fdde24